import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useErrors } from '../../../hooks/useErrors';
import { ValidatedWholeNumberTextInput } from '__components/Inputs/TextInput/presets/WholeNumber';

export const MaxConcurrentExecutionsInput: FC<{
  value?: number;
  onChange: (value: number) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const { clearError, validate, error } = useErrors(
    'max_concurrent_executions'
  );

  const handleChange = (v: number) => {
    onChange(v);
    clearError();
  };

  return (
    <ValidatedWholeNumberTextInput
      value={value}
      label={t('Max Concurrent Executions')}
      labelInfo={t(
        'Raising this value above 1 is not recommended for most Smart Connectors, and is usually not compatible with the "Only Process Rows that Contain New Data" setting'
      )}
      labelInfoPlacement="top"
      error={error}
      validate={validate}
      onChange={handleChange}
      margin
    />
  );
};
